module.exports = __webpack_public_path__ + "img/send-file.b2fa0c65.png";